import { JsonApiRequestError } from '@farfetched/core';
import { Store } from 'effector';
import {
	AccountReportAdditionalData,
	AccountReportRegistryFilters,
	AccountReportWithId,
	createAccountReportRegistryQuery,
} from 'shared/api';
import {
	createDateFilterModel,
	createRegistryModel,
	DateFilterModel,
	getToday,
	RegistryCallbacks,
	RegistryModel,
	SORT_DIRECTIONS,
} from 'shared/lib';

export type AccountReportRegistryModel = {
	model: RegistryModel<
		AccountReportWithId,
		AccountReportRegistryFilters,
		JsonApiRequestError,
		AccountReportAdditionalData
	>;
	dateFilterModel: DateFilterModel;
	$total: Store<AccountReportAdditionalData['summary'] | null>;
};

export type CreateAccountReportRegistryModelParams = RegistryCallbacks;

export const createAccountReportRegistryModel = (
	params: CreateAccountReportRegistryModelParams,
): AccountReportRegistryModel => {
	const query = createAccountReportRegistryQuery();

	const [, currentTimeZone] = getToday();

	const model = createRegistryModel<
		AccountReportWithId,
		AccountReportRegistryFilters,
		JsonApiRequestError,
		AccountReportAdditionalData
	>({
		query,
		filters: {
			currencies: [],
			accountIds: [],
			dateTo: '',
			dateFrom: '',
			timeZone: currentTimeZone,
		},
		sortField: 'name',
		sortDirection: SORT_DIRECTIONS.ASC,
		...params,
	});

	const $total = model.$additionalData.map((data) => data?.summary ?? null);

	const dateFilterModel = createDateFilterModel({
		fromChange: model.filters.dateFrom.setValue,
		toChange: model.filters.dateTo.setValue,
		reset: model.clearFilters,
		optional: true,
	});

	return { model, dateFilterModel, $total };
};
